import React from "react";
import Sugar from "sugar";

Sugar.extend();

function ScorecardDetailStats({ children }) {

  return (
    <div>
      { children }
    </div>
  );
}


function Title({ children })
{
  return <div className="header">{ children }</div>;
}

function Value({ value, ordinal })
{
  return <div className="value"><div>{ value }</div><div className="ordinal">{ ordinal }</div></div>;
}

function Meta({ children })
{
  return <div className="meta">{ children }</div>;
}

ScorecardDetailStats.Title = Title;
ScorecardDetailStats.Value = Value;
ScorecardDetailStats.Meta = Meta;

export default ScorecardDetailStats;
